import { useToast } from 'hooks/toasts/useToast';
import { useTranslation } from 'react-i18next';
import { COMMAND_EXECUTION_ERROR } from './subscriptions/GlobalSubscription';
import { useSubscription } from '@apollo/client'; // eslint-disable-line no-restricted-imports

const GlobalSubscriptionArea = () => {
  const [t] = useTranslation();
  const addToast = useToast();

  useSubscription(COMMAND_EXECUTION_ERROR, {
    onData: data => {
      const messageCode = data?.data?.data?.commandExecutionError?.code;
      const messageTranslated = t(messageCode);
      addToast(
        t('General.CommandExecutionError', { message: messageTranslated !== messageCode ? messageTranslated : messageCode }),
        'error'
      );
    }
  });

  return '';
};

export default GlobalSubscriptionArea;
